// pdGet + Equal Heights
$.fn.pdGet=function(e, t, n) {
	if (!this.length) {
		return this
	}
	var r;
	var i = Math[e];
	this.each(function(e) {
		var n = $(this)[t]();
		r = e ? i(r, n) : n
	});
	if (typeof n == "function") {
		n.call(this, Math.ceil(r));
		return this
	}
	return r
};
$.fn.pdEq=function(i, h) {
	Array.isArray(i) || (i = [i]), this.find(i.join(",")).css("height", ""), this.each(function() {
		var c = (typeof h === 'function' ? h.call(this) : h);
		for (var t = i.length, n = 0; t > n; n++) {
			var e = $(this).find(i[n]),
				f = e.length;
			if (c)
				for (var s = 0; f > s; s += c) e.slice(s, s + c).pdGet("max", "height", function(i) {
					this.height(i)
				});
			else e.pdGet("max", "height", function(i) {
				this.height(i)
			})
		}
	})
};

var EqualHeightItem = function(selector, ranges) {
	this.selector = selector;
	this.ranges = ranges;

	var l = this.ranges.length;
	this.resetEl = this.ranges[0].el;
	for (var i = 1; i < l; i++) {
		this.resetEl = pdTools.arrayUnion(this.resetEl, this.ranges[i].el);
	}
};
EqualHeightItem.prototype.eq = function(cssWidth, $elem) {
	var rangesLen = this.ranges.length;
	var matched = false;

	var $el = $elem || $(this.selector);

	$el.find(this.resetEl.join(',')).css('height', '');

	cssWidth = cssWidth || pdTools.getViewportWidth();

	for (var i = 0; i < rangesLen; i++) {
		if (this.ranges[i].from <= cssWidth && (this.ranges[i].to >= cssWidth || this.ranges[i].to === null)) {
			matched = true;

			$el.pdEq(this.ranges[i].el, this.ranges[i].count);
		}
	}
};


var equalHeights = {

	// Rozcestníky
	articleCrossroad: new EqualHeightItem('.js-eq-e-prescriptions-reasons', [
		{ from: null, to: 599,  el: ['.js-eq-e-prescriptions-reasons__eq'], count: 2 },
		{ from: 600,  to: 959,  el: ['.js-eq-e-prescriptions-reasons__eq'], count: 3 },
		{ from: 960,  to: 1099, el: ['.js-eq-e-prescriptions-reasons__eq'], count: 4 },
		{ from: 1100, to: null, el: ['.js-eq-e-prescriptions-reasons__eq'], count: 5 }
	]),

	storeList: new EqualHeightItem('.store-list', [
		{ from: 768, to: null,  el: ['.spc'], count: 2 }
	]),

	orderCross: new EqualHeightItem('.order-cross', [
		{ from: 900, to: null,  el: ['.spc'], count: 3 }
	]),

	// Produktové boxy
	productListMain: new EqualHeightItem('.js-product-list--main', [ // TODO: Redesign - move to TS after naja.js live
		{ from: 390,  to: 767,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 2 },
		{ from: 768,  to: 1279,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 3 },
		{ from: 1280,  to: null, el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 4 }
	]),

	productListFull: new EqualHeightItem('.js-product-list--full', [ // TODO: Redesign - move to TS after naja.js live
		{ from: 390,  to: 767,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 2 },
		{ from: 768,  to: 991,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 3 },
		{ from:1024,  to: 1279,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 4 },
		{ from: 1280,  to: null, el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 5 }
	]),

	productListDetail: new EqualHeightItem('.js-product-list--detail', [ // TODO: Redesign - move to TS after naja.js live
		{ from: 390,  to: 991,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 2 },
		{ from:1024,  to: null,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 3 }
	]),

	productListDetail: new EqualHeightItem('.js-product-list--article', [ // TODO: Redesign - move to TS after naja.js live
		{ from: 390,  to: 991,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 2 },
		{ from:1024,  to: null,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'], count: 3 }
	]),

	productListDetail: new EqualHeightItem('.js-product-list--carousel', [ // TODO: Redesign - move to TS after naja.js live
		{ from: null,  to: null,  el: ['.product-box__info', '.product-box__rating', '.product-box__name'] }
	]),

	products: new EqualHeightItem('.products:not(.lv-products, .full-products, .f-products, .variant-products, .qa-products, .rc-products, .quantity-products, .brand-products)', [
		{ from: null, to: 599,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 600,  to: 767,  el: ['.name', '.detail', '.in', '.shop-box'], count: 3 },
		{ from: 768,  to: 899,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 900,  to: 1099, el: ['.name', '.detail', '.in', '.shop-box'], count: 3 },
		{ from: 1100, to: null, el: ['.name', '.detail', '.in', '.shop-box'], count: 4 }
	]),

	productsFull: new EqualHeightItem('.products.full-products', [
		{ from: null, to: 599,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 600,  to: 767,  el: ['.name', '.detail', '.in', '.shop-box'], count: 3 },
		{ from: 768,  to: 1099, el: ['.name', '.detail', '.in', '.shop-box'], count: 4 },
		{ from: 1100, to: null, el: ['.name', '.detail', '.in', '.shop-box'], count: 5 }
	]),

	productListV2: new EqualHeightItem('.js-eq-product-list-v2', [
		{ from: null, to: 599,  el: ['.product-box-v2__heading', '.product-box-v2__category', '.product-box-v2__availability', '.product-box-v2__bg-p10'], count: 2 },
		{ from: 600,  to: 959,  el: ['.product-box-v2__heading', '.product-box-v2__category', '.product-box-v2__availability', '.product-box-v2__bg-p10'], count: 3 },
		{ from: 960,  to: null, el: ['.product-box-v2__heading', '.product-box-v2__category', '.product-box-v2__availability', '.product-box-v2__bg-p10'], count: 4 }
	]),

	brandProducts: new EqualHeightItem('.brand-products', [
		{ from: null, to: 599,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 600,  to: 899,  el: ['.name', '.detail', '.in', '.shop-box'], count: 3 },
		{ from: 900,  to: null, el: ['.name', '.detail', '.in', '.shop-box'], count: 5 }
	]),

	qualityProducts: new EqualHeightItem('.quantity-products', [
		{ from: 480,  to: 767,  el: ['.detail', '.in'], count: 2 },
		{ from: 768,  to: null, el: ['.detail', '.in'], count: 3 }
	]),

	productsRecommended: new EqualHeightItem('.products.rc-products', [
		{ from: 600,  to: null,  el: ['.name', '.detail', '.av-price'], count: 3 }
	]),

	variantProducts: new EqualHeightItem('.variant-products', [
		{ from: null, to: 599,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 600,  to: 767,  el: ['.name', '.detail', '.in', '.shop-box'], count: 3 },
		{ from: 768,  to: 899,  el: ['.name', '.detail', '.in', '.shop-box'], count: 2 },
		{ from: 900,  to: null, el: ['.name', '.detail', '.in', '.shop-box'], count: 3 }
	]),

	brandDetailProducts: new EqualHeightItem('.brand-detail__product-list', [
		{ from: null, to: 599,  el: ['.spc'], count: 2 },
		{ from: 600,  to: 959,  el: ['.spc'], count: 3 },
		{ from: 960,  to: null, el: ['.spc'], count: 5 }
	]),

	quickAddProducts: new EqualHeightItem('.qa-products-2', [
		{ from: 600,  to: null,  el: ['.detail', '.shop-box'], count: 2 }
	]),

	// Ostatní
	tabs: new EqualHeightItem('.js-tabs .tabs-nav', [
		{ from: null,  to: null,  el: ['a'] }
	]),


	// srovnání všeho
	eq: function(cssWidth) {
		for (var i in this) {
			if (this.hasOwnProperty(i) && this[i] instanceof EqualHeightItem) {
				this[i].eq(cssWidth)
			}
		}
	}
};
